export class VcUnitData{
  id:number;
  type:string;
  parent:{};

  constructor(no:number,parentId:number,parentName:string,type:string="endpoint") {
    this.id=no;
    this.type=type;
    this.parent={text:parentName,
      value:{id:parentId,
        type:"folder"}
    };
  }
}
